import Vue from 'vue'
import Vuex from 'vuex'
import defaultBoard from './default-board'
import { saveStatePlugin, uuid, getData } from '../../util/index'
import DocumentHttpService from "../../services/DocumentHttpService";

Vue.use(Vuex)

const board = defaultBoard;

export default new Vuex.Store({
    plugins: [saveStatePlugin],

    state: {
        board
    },
    getters: {
        getTask (state) {
            return (id) => {
                let currentColumn = '';
                let pos = 1;
                for (let column of state.board.columns) {
                    let tasks = [];
                    if(typeof column.tasks === 'object') {
                        tasks = Object.entries(column.tasks).map((e) => ( { [e[0]]: e[1] } ));
                        for(let i=0; i < tasks.length; i++) {
                            if (tasks[i][i].id === id) {
                                tasks[i][i].column = {
                                    name: column.name,
                                    position: pos
                                };
                                tasks[i][i].position = i+1;
                                return tasks[i][i];
                            }
                        }
                    }
                    pos++; // position increment
                }
            }
        },

        getTaskPositions(state) {
            return () => {
                let columns = [];
                let colIndex = 1;
                for (let column of state.board.columns) {
                    columns.push({
                        name: column.name,
                        id: colIndex,
                        length: column.tasks.length,
                    })
                    colIndex++;
                }

                return columns;
            }
        },

        getUser (state) {
            return () => {
                return state.board.user || {};
            }
        },

        getDate (state) {
            return () => {
                return state.board.created_at || {};
            }
        }
    },
    mutations: {
        CREATE_TASK (state, { tasks, name }) {
            name = name.replace(/(\r\n|\n|\r)/gm,"");
            if(name) {
                tasks.push({
                    name,
                    id: uuid(),
                    description: ''
                })
            }
        },
        CREATE_COLUMN (state, { name }) {
            name = name.replace(/(\r\n|\n|\r)/gm,"");
            if(name) {
                state.board.columns.push({
                    name,
                    tasks: []
                })
            }
        },
        UPDATE_TASK (state, { task, key, value }) {
            task[key] = value
        },
        MOVE_TASK (state, { fromTasks, toTasks, fromTaskIndex, toTaskIndex }) {
            if(! toTaskIndex) {
                toTaskIndex = toTasks.length;
            }
            const taskToMove = fromTasks.splice(fromTaskIndex, 1)[0]
            toTasks.splice(toTaskIndex, 0, taskToMove)
        },
        MOVE_COLUMN (state, { fromColumnIndex, toColumnIndex }) {
            const columnList = state.board.columns

            const columnToMove = columnList.splice(fromColumnIndex, 1)[0]
            columnList.splice(toColumnIndex, 0, columnToMove)
        },
        DELETE_ALL (state) {
            state.board.columns = defaultBoard.columns;
        },
        REMOVE_TASK (state, { task_id }) {

            state.board.columns.forEach((column, columnIndex) => {
                if(column.tasks && column.tasks.length) {
                    column.tasks = column.tasks.filter((task) => {
                        return (task.id != task_id);
                    });
                }
                // update that column
                state.board.columns[columnIndex] = column;
            });
        },
        REMOVE_COLUMN (state, { columnIndex }) {
            state.board.columns.splice(columnIndex, 1);
        },
        STORE (state) {
            let docService = new DocumentHttpService();
            let postData = {
                name: state.board.name,
                description: 'description',
                entity_name: 'Planner',
                entity_group: 'Planner',
                entity_data: state.board,
            }
            docService.store(postData).then(res => {
                console.error(response);
            }, function (response) {
                console.error(response);
            });
        },
        MOVE_POPUP_TASK (state, { fromColumnIndex, fromTaskIndex, toColumnIndex, toTaskIndex }) {
            let fromTasks = state.board.columns[fromColumnIndex].tasks;
            let toTasks = state.board.columns[toColumnIndex].tasks;
            const taskToMove = fromTasks.splice(fromTaskIndex, 1)[0]
            toTasks.splice(toTaskIndex, 0, taskToMove)
        },

        LOAD_DATA (state, {data}) {
            state.board = data;
        },

        UPDATE_COLUMN_NAME (state, { columnIndex, value }) {
            value = value.replace(/(\r\n|\n|\r)/gm,"");
            state.board.columns[columnIndex].name = value;
        },

        UPDATE_BOARD  (state, { key, value }) {
            state.board[key] = value
        },
     }
})
